export default function braintreeToken(state = {}, action) {
  if (action.type === 'RESET_BRAINTREE_TOKEN') {
    return { ...state, token: null }
  }

  return state
}
